import React from 'react';

import RouteWrapper from '../../../RouteWrapper';
import PlaylistsWrapper from '../../../PlaylistsWrapper';
import AutomixWrapper from '../../automix/AutomixWrapper';
import HistoryWrapper from '../../../HistoryWrapper';
import ShortcutsPanelWrapper from '../../shortcut/ShortcutsPanelWrapper';
import NavControlWrapper from '../../nav-control/NavControlWrapper';
import RecentTracksWrapper from '../../../RecentTracksWrapper';
// import OnBoardingWrapper from '../../../OnBoardingWrapper';
import TabletLayoutWrapper from '../../../TabletLayoutWrapper';
import PartyModeWrapper from '../../partymode/MainWrapper';
import TriggerWrapper from './mods/TriggerWrapper';
// import PathNotesWrapper from './mods/pathnotes/PathNotesWrapper';
import AccessWrapper from './content/AccessWrapper';

// TODO - Aircore replacement ?

// Module Available for the project
function CustomWrapper({ hasPlayer = true}) {
  // const firstLoad = (!localStorage.getItem('fl')); // DEPRECATED
  return (
    <>
      <RouteWrapper />
      <PlaylistsWrapper />
      <AutomixWrapper />
      <HistoryWrapper />
      <ShortcutsPanelWrapper />
      <NavControlWrapper />
      <RecentTracksWrapper />
      {/* { firstLoad && <OnBoardingWrapper /> } */}
      <TabletLayoutWrapper />
      <PartyModeWrapper />
      <TriggerWrapper />
      {/* <PathNotesWrapper /> */}
      <AccessWrapper />
    </>
  )
}

export default CustomWrapper;
